import { useRoutes, Navigate, Outlet } from 'react-router-dom';
// user context
import { UseUserState } from 'context/UserContext';

export default function LoginAuth({ children }) {
    const { isAuthenticated, authReady } = UseUserState();

    return <>{authReady ? children : 'cargando datos...'}</>;
}
